import React from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";

Modal.setAppElement("#root");

class CustomContentDialog extends React.Component {
  handleClose = result => {
    this.props.closeAction(result);
  };
  handleAccept = result => {
    this.props.acceptAction(result);
  };

  render() {
    let showCloseModal = this.props.showCloseModal ?? true
    return (
      <Modal
        isOpen={this.props.open}
        portalClassName="dialog confirm-dialog"
        overlayClassName="overlay"
        className={"content ".concat(
          this.props.class || this.props.className
            ? this.props.class || this.props.className
            : ""
        )}
      >
        {
          this.props.title ? <div className="title">{this.props.title}</div> : ''
        }
        {
          showCloseModal ? (
            <div className="close" onClick={() => this.handleClose(false)}></div>
          ):('')
        }
        <div className="message">
          {this.props.message}
          {this.props.contentObject}
        </div>
      </Modal>
    );
  }
}

export default CustomContentDialog;

CustomContentDialog.propTypes = {
  closeAction: PropTypes.func,
  acceptAction: PropTypes.func,
  open: PropTypes.bool.isRequired,
  class: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  contentObject: PropTypes.element,
  showCancel: PropTypes.bool,
  cancelText: PropTypes.string,
  cancelButtonType: PropTypes.string,
  acceptText: PropTypes.string,
  disabledAccept: PropTypes.bool
};

CustomContentDialog.defaultProps = {
  closeAction: () => {
    return false;
  },
  title: "",
  message: "",
  acceptText: "Continuar",
  acceptAction: () => {
    return true;
  },
  showCancel: false,
  cancelText: "Cancelar",
  disabledAccept: false,
  class: "",
  className: ""
};
